import {TypePack} from '../../core/model/type-pack.model';

export interface TypePackState {
  typePack: Array<TypePack> | null;
}

export const initializeTypePackState = function() {
  return [];
};
